import { Component, ViewChild } from '@angular/core'
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, FeatureType } from '../../shared'
import { CompanyDamageReportsComponent } from './company-damage-reports.component'
import { SafetyChecklistsDashboardComponent } from './safety-checklists-dashboard.component'
import { SafetyCorrectiveActionsComponent } from './safety-corrective-actions.component'
import { SafetyNearMissesComponent } from './safety-near-misses.component'
import { SafetyWorkAloneAuthsComponent } from './safety-work-alone-auths.component'
import { DailySafetyCoordinationMeetingsComponent } from './daily-safety-coordination-meetings.component'
import { EmployeeInjuryReportsComponent } from './employee-injury-reports.component'
import { ConfinedSpaceEntryPermitsComponent } from './confined-space-entry-permits.component'

@Component({
    selector: 'app-safety-checklists',
    templateUrl: './safety-checklists.component.html',
    standalone: true,
    imports: [
        NgbNav,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        SafetyChecklistsDashboardComponent,
        CompanyDamageReportsComponent,
        SafetyCorrectiveActionsComponent,
        SafetyNearMissesComponent,
        SafetyWorkAloneAuthsComponent,
        DailySafetyCoordinationMeetingsComponent,
        EmployeeInjuryReportsComponent,
        ConfinedSpaceEntryPermitsComponent,
    ],
})
export class SafetyChecklistsComponent extends BaseComponent {
    @ViewChild(SafetyChecklistsDashboardComponent)
    dashboard?: SafetyChecklistsDashboardComponent

    activeTab = 0
    recordsTab = 0

    constructor() {
        super()
        this.activeTab = this.canViewDashboard ? 0 : 1
        this.initialLoadingComplete()
    }

    tabChanged() {
        if (this.isDashboardTab) {
            this.dashboard?.refresh()
        }
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'))
        }, 50)
    }

    get canViewDashboard() {
        return this.services.authentication.hasFeature([FeatureType.SafetyChecklistDashboardView])
    }

    get isDashboardTab() {
        return Number(this.activeTab) === 0
    }

    get isRecordsTab() {
        return Number(this.activeTab) === 1
    }

    get isDamageRecordsTab() {
        return Number(this.recordsTab) === 0
    }

    get isCorrectiveActionRecordsTab() {
        return Number(this.recordsTab) === 1
    }

    get isNearMissRecordsTab() {
        return Number(this.recordsTab) === 2
    }

    get isWorkAloneRecordsTab() {
        return Number(this.recordsTab) === 3
    }

    get isDailyMeetingRecordsTab() {
        return Number(this.recordsTab) === 4
    }

    get isInjuryReportRecordsTab() {
        return Number(this.recordsTab) === 5
    }

    get isConfinedSpaceRecordsTab() {
        return Number(this.recordsTab) === 6
    }
}
